<app-temp-modal-cadastro #modalCadastro (closed)="onClose()" [textHeader]="'Importar CTe'">
  <form [formGroup]="cadastroForm" *ngIf="erros.length === 0">
    <div class="alert alert-danger" *ngIf="semCertificado || certificadoVencido">
      <span *ngIf="semCertificado">Importe <button class="btn btn-mini pointer"
          (click)="abrirCertificadoDigital()">aqui</button> o certificado digital para
        consultas de status!</span>
    </div>
    <file-upload formControlName="files">
      <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
        <div class="row div-upload">
          <div class="col-sm-3 div-upload-icon"><i class="fa fa-upload upload-icon"></i></div>
          <div class="col-sm-9" *ngIf="!cadastroForm.get('files').value">
            <span><b>Arraste e solte arquivos</b> ou clique aqui</span>
          </div>
        </div>
      </ng-template>
    </file-upload>
    <div class="text-center m-t-20">
      <button [disabled]="loading" class="btn btn-primary" (click)="importarNotas()">
        <app-loading texto="Importar" [loading]="loading" [icone]="'icofont icofont-refresh'"></app-loading>
      </button>
      <span>{{arquivosImportados()}}</span>
    </div>
  </form>

  <div *ngIf="erros.length > 0">
    <div class="alert alert-danger text-danger">
      A importação retornou erros. Esses documentos foram ignorados.
    </div>

    <ul>
      <li *ngFor="let erro of erros" class="mt-3">
        {{ erro }}
      </li>
    </ul>

    <div class="row mt-3">
      <div class="col">
        <button class="btn btn-info" (click)="onClose()">
          Fechar
        </button>
      </div>
    </div>
  </div>
</app-temp-modal-cadastro>

<app-abrir-modal #abrirModal></app-abrir-modal>
